import { FC } from 'react';
import { addDays, format, getDay } from 'date-fns';
import { useIntl } from 'react-intl';
import * as S from './styles';
import { Day } from './Day';
import { getDateFNSLocale } from './getDateFNSLocale';

interface CalendarProps {
  count: number;
}

export const Week: FC<CalendarProps> = ({ count }) => {
  const intl = useIntl();
  const firstDay = new Date();

  getDay(
    count >= 7
      ? firstDay?.setDate(firstDay?.getDate() - 6)
      : firstDay?.setDate(firstDay?.getDate() - count + 1),
  );

  const week = [...Array(7).keys()].map(n => addDays(firstDay, n));

  return (
    <S.Calendar data-testid="calendar">
      {week.map(day => (
        <S.DayWrapper key={day.getDate()}>
          <S.DayTitle>
            {format(day, 'cccccc', { locale: getDateFNSLocale(intl.locale) }).toUpperCase()}
          </S.DayTitle>
          <Day count={count} date={day} />
        </S.DayWrapper>
      ))}
    </S.Calendar>
  );
};
